import { useEffect, useState } from "react";
import { PromotionEnum } from "../../utility/enum/promotionEnum";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import { useFormik } from "formik";
import * as yup from 'yup';
import { PromotionEnumKey } from "../../utility/enum/promotionEnumKey";
import { getIBE_API } from "../../getAPIUrl";
import { getWidgetSessionToken, SESSION_TOKEN_HEADER } from "../../ibeAuth";
import { getLocalTime, updatePromoScName } from "../../utils";
import { useTranslation } from "../../utility/function/useTranslations";

const usePromotion = (setFieldValue: any, openClass: any, locale: string, isMobile: boolean = false, promotionOptionData: any = [], widgetValues: any = {}, isPageLoaded: boolean, setEventType?: any, eventType?: string) => {
    const {promotion: promotionValues} = widgetValues;
    const { t } = useTranslation();
    const getInitialValues = () => {
        if(promotionValues?.promotionCode1 && promotionValues?.promotionCode2)  {
            return {
                code_1: promotionValues?.promotionCode1,
                code_2: promotionValues?.promotionCode2
            }
        } else if(promotionValues?.promotionCode1) {
            return {code_1: promotionValues?.promotionCode1}
        }
        else {
            return {}
        }
    }
    const [open, setOpen] = useState(false);
    const [error, setError] = useState<any>({});
    const [selectedPromotion, setSelectedPromotion] = useState<any>(promotionValues?.promotionType || PromotionEnum.RegularRate);
    const [boxHidden, setBoxHidden] = useState(false);
    const [promotionOption, setPromotionOption] = useState<any>([]);
    const [loader, setLoader] = useState(false);
    const [validationSchema, setValidationSchema] = useState({code_1: yup.string().required(t('userPopup','thisIsRequiredField', locale))});

    const promotionFormIk : any = useFormik({
        initialValues: {
            codeValues: getInitialValues()
        },
        validationSchema: yup.object().shape({
            codeValues: yup.object().shape({...validationSchema})
        }),
        onSubmit: (values: any) => {

        },
        enableReinitialize: true,
        validateOnChange: true,
        validateOnMount: true
    })

    useEffect(() => {
        if(open) {
            setSelectedPromotion(promotionValues?.promotionType || PromotionEnumKey.RegularRate);
            promotionFormIk.setFieldValue('codeValues', getInitialValues(), true)
        }
    }, [open])

    const getSubCategory = (promotionKey: any, havePromotionCode: boolean) =>{
        if(!havePromotionCode) return [];
        return [{
            promoScId: Math.random(),
            pmScName: 'Offer Code'
        }]
    }

    useEffect(() => {
        const contractedPromotionOption = promotionOptionData.find((x: { key: string; }) => x?.key == PromotionEnumKey.contractedRate);
        const contractedPromotion = contractedPromotionOption?.subCategories.map((promotion: any) => {
            return {
                promoCatId: promotion?.promoScId,
                promoCatName: promotion?.pmScName,
                description: promotion?.description,
                key: promotion?.key,
                //subCategories: getSubCategory(promotion?.key, promotion?.havePromotionCode)
            }
        })
        const filterPromotionOption = promotionOptionData.filter((x: { key: string; }) => x?.key !== PromotionEnumKey.contractedRate);

        const ObjRegularRate = {
            promoCatId: PromotionEnum.RegularRate,
            promoCatName: t("promotion","regularRate", locale),
            description: 'Regular rates are the most affordable rate currently offered for booking a hotel room.',
            key: PromotionEnumKey.RegularRate
        }
        if(!filterPromotionOption.some((x: { key: PromotionEnumKey; }) => x?.key === PromotionEnumKey.RegularRate)) {
            filterPromotionOption.unshift(ObjRegularRate);
        }
        let allPromotionList = [];
        if(contractedPromotion?.length > 0) {
            allPromotionList = filterPromotionOption.concat(contractedPromotion);
        }
        else {
            allPromotionList = filterPromotionOption;
        }
        if((promotionOptionData?.length > 1 && (!allPromotionList.some((x: { key: any; }) => x?.key === promotionValues?.promotionType))) || (isPageLoaded && promotionValues?.promotionCode1)) {
            setSelectedPromotion(PromotionEnumKey.RegularRate);
            promotionFormIk?.setFieldValue('codeValues', {}, true);
            setFieldValue('promotion', {'promotionType': PromotionEnumKey.RegularRate, promotionCode1: '', promotionCode2: ''}, true)
        }
        setPromotionOption(updatePromoScName(allPromotionList).filter((x: { key: any; }) => x?.key !== "CUG" && x?.key !== "SMARTDISTRIBUTION"));

    }, [promotionOptionData])

    const getPromotionTooltip = (selectedPromotion: any) => {
        switch (selectedPromotion) {
            case PromotionEnumKey.RegularRate :
                return t("promotion","regularRateDescription", locale);
            case PromotionEnumKey.CorporateRate :
                return t("promotion","caaRateDescription", locale);
            case PromotionEnumKey.AgencyRate :
                return t("promotion","agencyRateDescription", locale);
            case PromotionEnumKey.Promotion_SpecialRate :
                return t("promotion","contentPromotionalSpecialRate", locale);
            case PromotionEnumKey.GovernmentMilitaryRate :
                return t("promotion","governmentRateDescription", locale);
            case PromotionEnumKey.SeniorCitizenRate :
                return t("promotion","seniorCitizenRateDescription", locale);
            case PromotionEnumKey.CAA_AAA_Rate :
                return t("promotion","caaRateDescription", locale);
            default:
                return "";
        }
    }

    const getSelectedPromotionText = (selectedPromotion: any, promotionCode: any) => {
        let promotion : any = {}
        if(promotionOption && promotionOption?.length > 0) {
            promotion = promotionOption.find((promotion: { key: any; }) => promotion?.key == selectedPromotion);
        }
        else {
            promotion = promotionOptionData.find((promotion: { key: any; }) => promotion?.key == selectedPromotion);
        }
        if(promotion?.key == PromotionEnumKey.RegularRate) {
            return `${t("promotion", "regularRate", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.CAA_AAA_Rate) {
            return `${t("promotion", "caaRate", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.GovernmentMilitaryRate) {
            return `${t("promotion", "governmentRate", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.SeniorCitizenRate) {
            return `${t("promotion", "seniorCitizen", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.CorporateRate) {
            return `${t("promotion", "CORP", locale)}: ${promotionCode}`
        }
        else if (promotion?.key == PromotionEnumKey.AgencyRate) {
            return `${t("promotion", "AGEN", locale)}: ${promotionCode}`
        }
        else if (promotion?.key == PromotionEnumKey.Promotion_SpecialRate) {
            return `${t("promotion", "PROM", locale)}: ${promotionCode}`
        }
        return promotion?.promoCatName;
    }

    const getTranslatedPromotionName = (promotion: any) => {
        if(promotion?.key == PromotionEnumKey.RegularRate) {
            return `${t("promotion", "regularRate", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.CAA_AAA_Rate) {
            return `${t("promotion", "caaRate", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.GovernmentMilitaryRate) {
            return `${t("promotion", "governmentRate", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.SeniorCitizenRate) {
            return `${t("promotion", "seniorCitizen", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.CorporateRate) {
            return `${t("promotion", "corporateRate", locale)}`
        }
        else if (promotion?.key == PromotionEnumKey.AgencyRate) {
            return `${t("promotion", "agencyRate", locale)}`
        }
        else if (promotion?.key == PromotionEnumKey.Promotion_SpecialRate) {
            return `${t("promotion", "promotionalSpecialRate", locale)}`
        }
    }

    const getTranslatedPromotionDescription = (promotion: any) => {
        if(promotion?.key == PromotionEnumKey.RegularRate) {
            return `${t("promotion", "regularRateDescription", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.CAA_AAA_Rate) {
            return `${t("promotion", "caaRateDescription", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.GovernmentMilitaryRate) {
            return `${t("promotion", "governmentRateDescription", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.SeniorCitizenRate) {
            return `${t("promotion", "seniorCitizenRateDescription", locale)}`
        }
        else if(promotion?.key == PromotionEnumKey.CorporateRate) {
            return `${t("promotion", "corporateRateDescription", locale)}`
        }
        else if (promotion?.key == PromotionEnumKey.AgencyRate) {
            return `${t("promotion", "agencyRateDescription", locale)}`
        }
        else if (promotion?.key == PromotionEnumKey.Promotion_SpecialRate) {
            return `${t("promotion", "contentPromotionalSpecialRate", locale)}`
        }
    }

    const handleChange = (event: any) => {
        const selectedPromotion = event.target.value;
        const promotion = promotionOption.find((promotion: { key: any; }) => promotion?.key == selectedPromotion);
        if(!promotion?.subCategories || promotion?.subCategories?.length == 0) {
            setFieldValue('promotion', {'promotionType': selectedPromotion, promotionCode1: '', promotionCode2: ''}, true)
            if(!isMobile){
                setEventType("");
            }
            setOpen(false);
        }

        setSelectedPromotion(selectedPromotion);
        setError({});
        promotionFormIk?.setFieldValue('codeValues', {}, true);
        promotionFormIk?.setFieldTouched('codeValues', {}, true);
        const validations: any = {};
        promotion?.subCategories?.forEach((key: any, index: number) => {
            validations[`code_${index + 1}`] = yup.string().required(t('userPopup','thisIsRequiredField', locale))
        })
        setValidationSchema(validations);
        promotionFormIk.validateForm();
    };

    const fetchCountryCodeByIP = async() => {
        return (
            await fetch('https://geolocation-db.com/json/').then(response => response.json()).then(data => {return(data?.country_code)})
            .catch(error => () =>{
                fetch('https://ipinfo.io/json/').then(response => response.json()).then(data => {return data?.country})
                .catch(error => console.log(error))
            }))
    }

    const applyPromotion = async() => {
        setLoader(true);
        const userAgent = navigator.userAgent;
        const platform = navigator.platform;
        // Extracting device type
        let deviceType = "Unknown Device";
        if (/Mobi|Android/i.test(userAgent)) {
            deviceType = "Mobile";
        } else if (/iPad|Tablet/i.test(userAgent)) {
            deviceType = "Tablet";
        } else if (/Win|Mac|Linux/i.test(platform)) {
            deviceType = "Desktop";
        }
  
        // Extracting OS Details
        let osDetails = ``;
        if (navigator.platform.startsWith("Win")) {
            osDetails = "Windows";
        } else if (navigator.platform.startsWith("iPhone") || navigator.platform.startsWith("iPad") || navigator.platform.startsWith("iPod")) {
            osDetails = "iOS";
        } else if (/Android/i.test(navigator.userAgent)) {
            osDetails = "Android";
        } else if (navigator.platform.startsWith("Mac")) {
            osDetails = "MAC OS X";
        } else if (navigator.platform.startsWith("Linux")) {
            osDetails = "Linux";
        } else if (navigator.platform.startsWith("CrOS")) {
            osDetails = "Chrome OS";
        } else {
            osDetails = "Others";
        }
        let countryCode = await fetchCountryCodeByIP();
        const [value1, value2] = Object.values(promotionFormIk.values.codeValues);
        const promoCatId = promotionOptionData?.find((x: { key: any; }) => x.key === selectedPromotion)?.promoCatId;
        const requestPayload = constructReqBody(_.cloneDeep(widgetValues), promoCatId, value1, value2, deviceType, osDetails, countryCode);
        const IBE_lOCATION_API = getIBE_API();
        const brandId = widgetValues?.brandID || widgetValues?.brandId || '';
        const chainId = widgetValues?.chainID || widgetValues?.chainId || '';
        const sessionToken = brandId && chainId ? await getWidgetSessionToken(brandId, chainId) : null;
        const response = await axios.post(
          `${IBE_lOCATION_API}/Promotions/ValidatePromotions`,
          requestPayload,
          sessionToken ? { headers: { [SESSION_TOKEN_HEADER]: sessionToken } } : undefined
        );
        if(response?.data?.body?.isPromotionValid) {
            setFieldValue('promotion', {'promotionType': selectedPromotion, promotionCode1: value1, promotionCode2: value2}, true)
            if(!isMobile){
                setEventType("");
            }
            setOpen(false);
            setError({})
            setLoader(false);
        }
        else {
            const res = response?.data?.body;
            let errorRes = {};
            if(value2) {
                errorRes = {
                    code_1: {
                        isValid: !res.isVendorCodeValid,
                        errorMessage: res?.vendorCodeMessage
                    },
                    code_2: {
                        isValid: !res.isPromotionCodeValid,
                        errorMessage: res?.promotionCodeMessage
                    }
                }
            }
            else {
                errorRes = {
                    code_1: {
                        isValid: !res.isPromotionCodeValid,
                        errorMessage: res?.promotionCodeMessage
                    }
                }
            }
            setError(errorRes);
            setLoader(false)
        }
    }

    const onCodeChange = (code: string, promotionFormIk: any = () => {}) => {
        const touchedField = {..._.cloneDeep(promotionFormIk?.touched?.codeValues)}
        // const updateValues = {
        //     ...touchedField,
        //     [code]: true
        // }
        // console.log(promotionFormIk)
        // setFieldTouched('codeValues', updateValues, true)
        setError(false)
        //promotionFormIk.handleBlur();
        promotionFormIk.validateForm();
    }

    const handleClear = (key: string) => {
        setError(false);
        const values = _.cloneDeep(promotionFormIk.values.codeValues)
        const updateValues = {
            ...values,
            [key]: ''
        }

        promotionFormIk?.setFieldValue('codeValues', updateValues, true);
    }

    const handleCloseFilter = () => {
        setOpen(false);
    }

    const handleFilterOpen = () => {
        setOpen(prevState => !prevState);
        dropdownPosition();
    };

    const dropdownPosition = () =>{
        const boxElement = document.getElementById('IBE_Rate_Pos');
        if (!boxElement) return;

          const boxPosition = boxElement.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          if (boxPosition.bottom < 0 || boxPosition.top + boxPosition.bottom > windowHeight) {
            //(boxPosition.top + boxPosition.bottom)
              setBoxHidden(true);
          }
          else {
              setBoxHidden(false);
        }
    }

    useEffect(() => {
      const handleScroll = () => {
        const delay = 750; // Adjust this value as needed
        const timerId = setTimeout(() => {
            // Call your function here or set a flag to indicate typing is finished
            dropdownPosition();
        }, delay);

        return () => {
            clearTimeout(timerId);
        };
      };

      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
      };
    }, []);

    useEffect(() => {
        if(isMobile) {
            setOpen(openClass)
        }
    }, [openClass])

    useEffect(() => {
        if(open && eventType=="" && !isMobile) {
            setOpen(false);
        }
    }, [eventType]);

    const constructReqBody: any = (widgetData: any, selectedPromotion: string, value1: any, value2: any, deviceType: any, osType: any, userLocation: any) => {
        const destination = widgetData?.destination;
        let country, city, propertyId, pincode;
        let obj = {};
        switch (Number(widgetData?.destination?.type)) {
            case 0:
                country = destination?.id;
                break;
            case 1:
                city = destination?.id;
                break;
            case 2:
                propertyId = destination?.id;
                break;
            case 3:
                pincode = destination?.id;
                break;
            default:
                break;
        }
        // To do create interface for below obj
        if (widgetData?.destination != undefined) {
            obj = {
                "chainID": widgetData?.chainID,
                "brandID": widgetData?.brandID,
                "propertyId": propertyId ?? "",
                "country": country ?? "",
                "city": city ?? "",
                "pincode": pincode ?? "",
                "checkIn": parseDateformat(getDateFromString(widgetData?.checkInDate)),
                "checkOut": parseDateformat(getDateFromString(widgetData?.checkOutDate)),
                "guest": widgetData?.guest.map((guest: any) => {
                    return {
                        adult: guest?.adultCount,
                        child: guest?.childCount,
                        roomNo: guest?.roomCount
                    }
                }),
                "promotionCategoryId": selectedPromotion,
                "PromVendorCode": value2 ? value1 : '',
                "promotionCode": value2 ? value2 : value1,
                "userTime": getLocalTime(),
                "deviceType": deviceType,
                "osDetails": osType,
                "userLocation": userLocation,
                "channels": [deviceType=="Mobile"? process.env.REACT_APP_MOBILE_CHANNEL_ID: process.env.REACT_APP_WEB_CHANNEL_ID] 
            }
        }
        return removeBlankKeys(obj);
    }

    const removeBlankKeys = (obj: any) => {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (!obj[key] && obj[key] !== false) {
                    delete obj[key];
                }
            }
        }
        return obj;
    }

    const parseDateformat= (currentDate: any)=>{
        try {
            var month : any = parseInt(currentDate.getMonth()+1) > 9 ?
            (parseInt(currentDate.getMonth()+1)).toString() : '0'+(currentDate.getMonth()+1)
            var day: any = parseInt(currentDate.getDate()) >9 ? parseInt(currentDate.getDate()).toString() : '0'+ parseInt(currentDate.getDate()).toString()
        } catch{
        }

        return `${currentDate.getFullYear()}-${month}-${day}`;
    }

    const getDateFromString = (dateUnformatted:any): any => {
        try{
            if(dateUnformatted.includes('-')){
                var date_spilt : any= dateUnformatted.split("-");
                var day = date_spilt[2]?.includes('T') ? date_spilt[2].split('T')[0]: date_spilt[2];
                var formattedDate = new Date(date_spilt[0], date_spilt[1] - 1, day);
                return formattedDate;
            }
            else{
                var parsedDate = moment(dateUnformatted, "ddd MMM D YYYY");
                var date = parsedDate.format("YYYY-MM-DD");
                date_spilt= date.split("-");
                var formattedDate = new Date(date_spilt[0], date_spilt[1] - 1, date_spilt[2]);
                return formattedDate;
            }
        } catch {
            return new Date(dateUnformatted);
        }
    }

    return {
        getPromotionTooltip,
        promotionOption,
        getSelectedPromotionText,
        handleCloseFilter,
        handleFilterOpen,
        handleClear,
        onCodeChange,
        applyPromotion,
        handleChange,
        error,
        open,
        selectedPromotion,
        boxHidden,
        constructReqBody,
        loader,
        promotionFormIk,
        getTranslatedPromotionName,
        getTranslatedPromotionDescription
    }
}

export default usePromotion;